export default __webpack_public_path__ + "static/media/star.618d11e1.png";